// extracted by mini-css-extract-plugin
export var cardLayout = "_8r-1";
export var paginationContainer = "_8r-0";